// InstagramCallbackPage.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../api';
import styled from 'styled-components';
import { Button } from '../../components/common/Button';

// Estilização simples para o erro
const Container = styled.div`padding: 50px; text-align: center; max-width: 600px; margin: 0 auto;`;
const Title = styled.h2`color: #333; margin-bottom: 1rem;`;
const Message = styled.p`font-size: 1.1rem; color: #666; margin-bottom: 2rem;`;
const ErrorMessage = styled.div`background: #fee; color: #c0392b; padding: 1rem; border-radius: 8px; margin-bottom: 2rem; border: 1px solid #f5c6cb;`;

const InstagramCallbackPage = () => {
  const [status, setStatus] = useState('Autenticando e verificando permissões...');
  const [errorDetails, setErrorDetails] = useState(null); // Novo estado para erro
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const errorParam = params.get('error');

    // 1. Erro vindo direto do Instagram (User cancelou ou erro da Meta)
    if (errorParam) {
      setStatus('Conexão cancelada ou falhou.');
      setErrorDetails(params.get('error_description') || 'A autorização foi negada.');
      return;
    }

    // 2. Processar Código
    if (code) {
      const exchangeCodeForToken = async () => {
        try {
          await apiClient.post('/api/auth/instagram/callback', { code });
          
          setStatus('Sucesso!');
          setErrorDetails(null);
          
          // Fecha o popup se foi aberto como popup, senão redireciona
          if (window.opener) {
            window.opener.focus(); // Foca na janela pai
            window.close(); // Fecha o popup
          } else {
            navigate('/perfil');
          }

        } catch (err) {
          console.error('Erro backend:', err);
          
          // Pega a mensagem de erro específica que mandamos do Python (Limite do plano)
          const msg = err.response?.data?.error || 'Ocorreu um erro desconhecido.';
          
          setStatus('Não foi possível conectar.');
          setErrorDetails(msg);
        }
      };

      exchangeCodeForToken();
    } else {
        setStatus('Código inválido.');
        setTimeout(() => navigate('/perfil'), 3000);
    }
  }, [location, navigate]);

  return (
    <Container>
      <Title>{errorDetails ? 'Atenção' : 'Processando...'}</Title>
      
      {errorDetails ? (
        <>
            <ErrorMessage>{errorDetails}</ErrorMessage>
            <Button onClick={() => window.opener ? window.close() : navigate('/perfil')}>
                Fechar e Voltar
            </Button>
        </>
      ) : (
        <Message>{status}</Message>
      )}
    </Container>
  );
};

export default InstagramCallbackPage;